import { Nav, Pagination } from 'react-bootstrap';
import { Paging } from '../../../model/paging.model';


interface IOwnProps {
    paging?: Paging;
    onClick: (page: number) => void;
}

export default function PagingComponent({ paging, onClick }: IOwnProps) {
    const renderLinks = () => {
        const items = [];
        if (paging) {
            const linkStart = Math.max(1, paging.page - 4);
            const linkEnd = Math.min(paging.total_pages, paging.page + 4);
            items.push(
                <Pagination.Item key="page-first" disabled={1 === paging.page} onClick={() => onClick(1)}>
                    First
                </Pagination.Item>,
            );

            for (let number = linkStart; number <= linkEnd; number++) {
                items.push(
                    <Pagination.Item key={`page-${number}`} active={number === paging.page} onClick={() => number !== paging.page && onClick(number)}>
                        {number}
                    </Pagination.Item>,
                );
            }

            items.push(
                <Pagination.Item key="page-last" disabled={paging.total_pages === paging.page} onClick={() => onClick(paging.total_pages)}>
                    Last
                </Pagination.Item>,
            );

        }
        return items;
    };

    return <Nav aria-label="Paging" className='d-flex justify-content-center'>
        <Pagination>
            {renderLinks()}
        </Pagination>
    </Nav>;
};